<div class="">
  @if (isCanceledOffer) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13 text-red">Offre de mission annulée</div>
    </div>
  } @else {
  @if (totallyValidated) {
    <div class="d-flex align-items-center gap-4">
      <div class="fs-13 text-accent-green">{{ totallyValidated }}</div>
    </div>
  } @else if (expired) {

    @if (totallyValidated) {
      <div class="d-flex align-items-center gap-4">
        <div class="fs-13 text-accent-green">{{ totallyValidated }}</div>
      </div>
    } @else {
      @if (candidatList && candidatList.length > 0 && statusCandidateAccepted) {
        @switch (statusCandidateAccepted) {
          @case (CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
            <div class="d-flex align-items-center gap-4">
              <div class="fs-13 required">En attente de validation</div>
            </div>
          }
        @case (CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Validée en attente de paiement</div>
          </div>
        }
        @case (CandidatStatusOnMission.PAYMENT_DONE) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Paiement effectué</div>
          </div>
        }
        @case (CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Validation refusée par l'établissement</div>
          </div>
        }
        @case (CandidatStatusOnMission.CANCELED_BY_CANDIDATE) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Candidature annulée par le candidat</div>
          </div>
        }
        @case (CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Candidature annulée par vous</div>
          </div>
        }
        @case (CandidatStatusOnMission.ARCHIVED) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Candidature annulée par l'établissement</div>
          </div>
        }
        @case (CandidatStatusOnMission.ACCEPTED) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Contrat non signé par le professionnel de santé</div>
          </div>
        }
          @default {
            <div class="d-flex align-items-center gap-4">
              <div class="fs-13 text-accent-action">Terminée</div>
            </div>
          }
        }
      } @else {
        <div class="fs-13 required">Terminée</div>
      }

    }


  } @else if (!statusCandidateAccepted) {

    @switch (_data.missionStatus) {
      @case (MissionStatusEnum.PENDING) {
        <div class="d-flex align-items-center gap-4">
          @if (isTotallyAffected()) {
            <div class="fs-13 text-accent-action">Offre de mission totalement affectée</div>
          } @else if (isAccepted()) {
            <div class="fs-13 text-accent-action">Acceptée</div>
          } @else if (isContractWaitingToBevalidated()) {
            <div class="fs-13 text-accent-action">Contrat en attente de validation</div>
          } @else  {
            <div class="fs-13 text-accent-action">Publiée en attente</div>
          }

        </div>
      }
      @case (MissionStatusEnum.DRAFT) {
        <div class="d-flex align-items-center align-items-center gap-2">
          <div class="fs-13 text-accent">Brouillon</div>
          <div class="d-flex gap-1 justify-content-center">
          </div>
        </div>

      }
      @case (MissionStatusEnum.FRAGMENTED_NOT_ALL_ASIGNED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">
            Offre de mission partiellement affectée
          </div>
        </div>
      }
      @case (MissionStatusEnum.FRAGMENTED_ALL_ASIGNED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">Offre de mission totalement affectée</div>
        </div>
      }
      @case (MissionStatusEnum.CANCELED) {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-red">Offre de mission annulée</div>
        </div>
      }
      @default {
        <div class="d-flex align-items-center gap-4">
          <div class="fs-13 text-accent-action">En cours</div>
        </div>
      }
    }


  } @else {
    <div class="">
      @switch (statusCandidateAccepted) {
        @case (CandidatStatusOnMission.ACCEPTED) {
          @if (expired && _data.missionStatus == CandidatStatusOnMission.INVALIDATED) {
            <div class="d-flex align-items-center gap-4 flex-wrap">
              <div class="fs-13 text-accent-yellow d-flex gap-2">
                <svg-icon src="assets/icons/warning.svg"></svg-icon>
                À valider
              </div>
            </div>
          } @else if (expired && _data.missionStatus == CandidatStatusOnMission.VALIDATED) {
            <div class="fs-13 text-accent-green">Valider</div>

          } @else {
            <div class="d-flex align-items-center gap-1 flex-wrap">
              <div class="fs-13 text-accent-green">Acceptée</div>
            </div>
          }
        }
        @case (CandidatStatusOnMission.PAYMENT_DONE) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Payé</div>
          </div>
        }
        @case (CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green">Offre totalement affectée</div>
          </div>
        }
        @case (CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green"
                 [tooltip]="'Le professionnel de santé a postulé pour cette mission. Nous sommes en attente de la confirmation de l’établissement'">
               Candidature en attente
            </div>
          </div>
        }
        @case (CandidatStatusOnMission.REJECTED) {
          <div class="d-flex align-items-center gap-1">
            <div class="fs-13 text-accent-green"
                 [tooltip]="'Le professionnel de santé a postulé pour cette mission. Nous sommes en attente de la confirmation de l’établissement'">
              Candidature refusée
            </div>
          </div>
        }
        @case (CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">En attente de validation</div>
          </div>
        }
        @case (CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 text-accent-green">Validée en attente de paiement</div>
          </div>
        }
        @case (CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT) {
          <div class="d-flex align-items-center gap-4">
            <div class="fs-13 required">Validation refusée par l'établissement</div>
          </div>
        }
        @default {
          <div class="fs-13 text-secondary">{{ totallyValidated || '—' }}</div>
        }
      }
    </div>

  }
  }

</div>
